import './as-header-set.ts';
import '../../base/buttons/as-icon-button.ts';
import './as-viewcube-v1';
import { devlog } from '../../../logic/utils.ts';
import styleText from './as-view-set.css?raw';

/**
 * View controls section component
 */
export class TrViewSet extends HTMLElement {
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();
  private viewport?: any; //TODO: fix paramate

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      TrViewSet.sheet
    ];
    
    this.shadowRoot!.innerHTML = /*html*/`
      <div set-id="header-view-set">
        <!-- <as-viewcube-v1></as-viewcube-v1> -->
        <as-icon-button 
          file-name="header/view-perspective.png"
          tooltip-dict-key="tooltip.view.perspective"
          tooltip-default-text="Toggle perspective view"
          name="toggle-perspective"
        ></as-icon-button>
        <as-icon-button 
          file-name="header/view-fit.png" 
          black
          tooltip-dict-key="tooltip.view.fit"
          tooltip-default-text="Fit to screen"
          name="view-fit"
        ></as-icon-button>
        <as-icon-button 
          file-name="header/view-iso.png" 
          black
          tooltip-dict-key="tooltip.view.iso"
          tooltip-default-text="Isometric view"
          name="view-iso"
        ></as-icon-button>
        <as-icon-button 
          file-name="header/view-front.png" 
          black
          tooltip-dict-key="tooltip.view.front"
          tooltip-default-text="Toggle front/back view"
          name="view-front"
        ></as-icon-button>
        <as-icon-button 
          file-name="header/view-right.png" 
          black
          tooltip-dict-key="tooltip.view.right"
          tooltip-default-text="Toggle right/left view"
          name="view-right"
        ></as-icon-button>
        <as-icon-button 
          file-name="header/view-top.png" 
          black
          tooltip-dict-key="tooltip.view.top"
          tooltip-default-text="Toggle top/bottom view"
          name="view-top"
        ></as-icon-button>
      </div>
    `;

    this.setupEventListeners();
  }

  private setupEventListeners(): void {
    const set = this.shadowRoot!.querySelector('tr-header-set');
    if (!set) return;

    const buttons = Array.from(set.children);
    const events = [
      { event: 'toggle-perspective' },
      { event: 'auto-pos-camera' },
      { event: 'set-view', data: 'top_front_left' },
      { event: 'toggle-default-view', data: 'front' },
      { event: 'toggle-default-view', data: 'right' },
      { event: 'toggle-default-view', data: 'top' }
    ];

    buttons.forEach((button, index) => {
      button.addEventListener('header-button-clicked', () => {
        this.dispatchEvent(new CustomEvent(events[index].event, {
          bubbles: true,
          composed: true,
          detail: { data: events[index].data }
        }));
      });
    });
  }

  connectedCallback() {
    // Listen for viewport registration
    document.addEventListener('register-viewport', (event: CustomEvent) => {
      this.viewport = event.detail?.viewport;
    });

    // Handle view control events
    this.addEventListener('toggle-perspective', (e: Event) => {
      devlog('Toggle perspective view', e);
    });

    this.addEventListener('auto-pos-camera', () => {
      this.viewport?.autoPosCamera?.(true);
    });

    this.addEventListener('set-view', (e: CustomEvent) => {
      devlog('Set view:', e.detail.data);
    });

    this.addEventListener('toggle-default-view', (e: CustomEvent) => {
      devlog('Toggle default view:', e.detail.data);
    });
  }
}

customElements.define('as-view-set', TrViewSet); 




